import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'

export default ({ node }) => (
  <div>
    <SimpleTable>
      <div>
        <div>Event Name:</div>
        <div>{node.extras.name}</div>
      </div>
    </SimpleTable>
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendAnalyticsEvent/SendAnalyticsEventDisplay.jsx